import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { motion } from 'framer-motion';
import { Monitor, Users, Crown, Check, Briefcase, PartyPopper, Star, Download, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CorporateEvents() {
  const features = [{
    icon: Monitor,
    title: 'Business Presentations',
    description: 'Utilize our 190ft immersive screen for impactful presentations, product launches, and corporate announcements.'
  }, {
    icon: Users,
    title: 'Team Building',
    description: 'Private events with customizable entertainment, premium dining, and networking opportunities for your team.'
  }, {
    icon: Crown,
    title: 'VIP Experiences',
    description: 'Exclusive access to our premium spaces with dedicated staff, custom menus, and bottle service packages.'
  }];
  const packages = [{
    icon: Briefcase,
    title: 'Executive Package',
    description: 'Perfect for board meetings and executive gatherings. Includes private dining area, A/V equipment, and premium catering.',
    price: 'Starting at $2,500',
    capacity: 'Up to 25 guests'
  }, {
    icon: PartyPopper,
    title: 'Team Celebration Package',
    description: 'Celebrate milestones with style. Full venue access, DJ, custom menu, and entertainment on our massive screen.',
    price: 'Starting at $5,000',
    capacity: 'Up to 100 guests'
  }, {
    icon: Star,
    title: 'Premium Corporate Package',
    description: 'The ultimate corporate experience. Entire venue buyout, celebrity host, premium bottle service, and custom entertainment.',
    price: 'Starting at $15,000',
    capacity: 'Up to 200+ guests'
  }];
  const includedItems = ['Dedicated event coordinator', '190ft immersive video wall access', 'Premium sound system', 'Custom menu options', 'VIP bottle service', 'Professional staff service', 'Customizable lighting & ambiance', 'Complimentary WiFi'];
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-907">
      <Header data-id="element-908" />

      <main className="pt-32 pb-24 px-4 md:px-8 max-w-[1600px] mx-auto" data-id="element-909">
        {/* Hero Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-910">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-wide uppercase" data-id="element-911">
            Corporate Events
          </h1>
          <div className="w-24 h-1 bg-[#DDA247] mx-auto mb-8" data-id="element-912" />
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-913">
            Looking for the perfect space to host a business mixer or private
            affair? House of Flavors offers luxury and flexibility for corporate
            groups with our 190ft immersive video wall and premium amenities.
          </p>
        </motion.div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24" data-id="element-914">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className="bg-[#11161A] border border-white/5 p-8 text-center group hover:border-[#DDA247]/30 transition-colors duration-300" data-id="element-915">
              <div className="inline-flex items-center justify-center w-16 h-16 mb-6 bg-[#DDA247]/10 rounded-full group-hover:bg-[#DDA247]/20 transition-colors duration-300" data-id="element-916">
                <feature.icon className="w-8 h-8 text-[#DDA247]" data-id="element-917" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4 tracking-wide" data-id="element-918">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-919">
                {feature.description}
              </p>
            </motion.div>)}
        </div>

        {/* Event Packages */}
        <div className="mb-24" data-id="element-920">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-921">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-wide" data-id="element-922">
              EVENT PACKAGES
            </h2>
            <div className="w-16 h-1 bg-[#DDA247] mx-auto" data-id="element-923" />
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-924">
            {packages.map((pkg, index) => <motion.div key={pkg.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} className="bg-[#11161A] border border-white/10 p-8 flex flex-col relative overflow-hidden group hover:border-[#DDA247]/50 transition-all duration-300" data-id="element-925">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#DDA247] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-926" />

                <div className="mb-6" data-id="element-927">
                  <pkg.icon className="w-10 h-10 text-[#DDA247] mb-4" data-id="element-928" />
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-929">
                    {pkg.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed mb-6 min-h-[60px]" data-id="element-930">
                    {pkg.description}
                  </p>
                </div>

                <div className="mt-auto pt-6 border-t border-white/10" data-id="element-931">
                  <div className="flex flex-col gap-1 mb-6" data-id="element-932">
                    <span className="text-[#DDA247] font-bold text-lg" data-id="element-933">
                      {pkg.price}
                    </span>
                    <span className="text-gray-500 text-sm font-medium uppercase tracking-wider" data-id="element-934">
                      {pkg.capacity}
                    </span>
                  </div>
                  <Link to="/contact" data-id="element-935">
                    <Button variant="primary" fullWidth data-id="element-936">
                      Request Corporate Quote
                    </Button>
                  </Link>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* What's Included */}
        <div className="mb-24 bg-[#11161A] border border-white/5 rounded-2xl p-8 md:p-12" data-id="element-937">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-938">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-wide" data-id="element-939">
              WHAT'S INCLUDED
            </h2>
            <div className="w-16 h-1 bg-[#DDA247] mx-auto" data-id="element-940" />
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-941">
            {includedItems.map((item, index) => <motion.div key={item} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-center space-x-3 bg-[#0B1014] p-4 rounded border border-white/5" data-id="element-942">
                <Check className="w-5 h-5 text-[#DDA247] flex-shrink-0" data-id="element-943" />
                <span className="text-gray-300 text-sm font-medium" data-id="element-944">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>

        {/* CTA Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative rounded-3xl overflow-hidden" data-id="element-945">
          <div className="absolute inset-0 bg-gradient-to-r from-[#DDA247]/20 to-[#0B1014] z-0" data-id="element-946" />
          <div className="absolute inset-0 bg-[#0B1014]/80 z-0" data-id="element-947" />

          <div className="relative z-10 p-10 md:p-16 text-center" data-id="element-948">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-949">
              Ready to Plan Your Corporate Event?
            </h2>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-10" data-id="element-950">
              Contact our corporate events team to discuss your vision and
              receive a custom proposal.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-951">
              <Link to="/contact" data-id="element-952">
                <Button variant="primary" size="lg" data-id="element-953">
                  <Calendar className="w-5 h-5 mr-2" data-id="element-954" />
                  Schedule Consultation
                </Button>
              </Link>
              <Button variant="outline" size="lg" data-id="element-955">
                <Download className="w-5 h-5 mr-2" data-id="element-956" />
                Download Brochure
              </Button>
            </div>
          </div>
        </motion.div>
      </main>

      <Footer data-id="element-957" />
    </div>;
}